import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { validationACC } from '../../../utils/validations';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { createAdminContactCenter, updateAdminContactCenter } from '../../../configs/environments/firebase/firebaseApp';
import AddACCForm from './AddACCForm';
import './AddACC.scss'

const AddACC = ({
    handleClose,
    valuesToEdit,
    searchEvery,
    handleSnack,
    showLoading,
    hideLoading,
    isModal,
    uid,
}) => { 

    const handleCloseState = () => {
        if (handleClose) {
            handleClose()
        }
        if (searchEvery) {
            searchEvery()
        }
    }

    const handleSubmit = async (values) => {
        showLoading()
        try {
            let res
            if (!valuesToEdit) {
                res = await createAdminContactCenter(values)
            } else {
                res = await updateAdminContactCenter(values, valuesToEdit.uid)
            }
            hideLoading()
            console.log('res', res);
            handleSnack()
            handleCloseState()
        } catch (error) {
            hideLoading()
            console.log('error', error);
            handleCloseState()
        }
    }

    const formValues = {
        names: valuesToEdit ? valuesToEdit.names : '',
        email: valuesToEdit ? valuesToEdit.email : '',
        password: valuesToEdit ? valuesToEdit.password : '',
        createBy: valuesToEdit ? valuesToEdit : uid,
        active: true
    }

    return (
        <div className={isModal ? 'addACCModal' : 'addACC'}>
            <p className={isModal ? 'addACCModal_title' : 'addACC_title'}>
                {valuesToEdit ?
                    'Editar usuario Contact Center' :
                    'Agregar usuarios Contact Center'
                }
            </p>
            <Formik
                initialValues={formValues}
                validationSchema={validationACC}
                onSubmit={handleSubmit}
                render={props =>
                    <AddACCForm
                        {...props}
                        isModal={isModal}
                    />
                }
            />
        </div>
    )
}

const mapStateToProps = state => ({
    uid: state.authClient.uid
})

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddACC);
